import React from 'react';
import classNames from 'classnames';

function bookImage(book) {
    let id = book['.key'].toString();
    let subdir = id.substring(id.length - 3);
    return `http://www.smakprov.se/l/${subdir}/${book['.key']}.png`;
}

const BookDropdown = React.createClass({

    onClickBook(clickedBookKey) {
        this.props.handleClickBook(clickedBookKey);
    },

    render() {
        let ulClass = classNames({
            'hidden': !this.props.visible
        });
        return (
            <div className="book-dropdown">
                {this.props.children}
                <ul className={ulClass}>
                    {this.props.filteredBooks.map(filteredbook => {
                        return (
                            <li key={filteredbook['.key']} onClick={this.onClickBook.bind(this, filteredbook['.key'])}>
                                <img src={bookImage(filteredbook)} alt={filteredbook.title}/>{filteredbook.title} -
                                ISBN:{filteredbook['.key']}
                            </li>
                        );
                    })}
                </ul>
            </div>
        );
    }

});
export default BookDropdown;


/** WEBPACK FOOTER **
 ** ./src/components/BookDropdown/BookDropdown.js
 **/